// removed by extract-text-webpack-plugin
module.exports = {"text":"text__lJxlb","rect":"rect__1hw1k","img":"img__2gdCk","sdgImage":"sdgImage__RARRp","sdgCircle":"sdgCircle__2Bk03","toolTip":"toolTip__Q_n8m","head":"head__DiQcn","sdgWrapper":"sdgWrapper__AZNT7","backButtonContainer":"backButtonContainer__34GZW","backButton":"backButton__uA8aF","backImg":"backImg__2nq2n","embedArray":"embedArray__3GhMc","leftArray":"leftArray__2xyKG","rightArray":"rightArray__2G7Kx","svgIe":"svgIe__TFaKa"};


//////////////////
// WEBPACK FOOTER
// ./components/paSunburstChart/style.scss
// module id = iN9L
// module chunks = 0